import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useGetProductGroupsForOffer } from '@occc-app/dataAccessLayer/productGroup/queries';
import { createRouteCreator } from '@occc-app/routes/CampaignComponents/utils';

import { ConfigureForm } from './ConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { OfferConfigureFormInitialValues, OfferConfigureFormValues } from '../../types';

export const OfferConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const { offer, campaignId, offerId, type } = props;
  const navigate = useNavigate();
  const productGroups = useGetProductGroupsForOffer(offer);
  const transformOfferToInitialValuesWithProductGroups = useCallback(
    (currentOffer: Parameters<typeof transformOfferToInitialValues>[0]) =>
      transformOfferToInitialValues(currentOffer, productGroups),
    [productGroups],
  );

  const handleSubmitSuccess = useCallback(
    (values: OfferConfigureFormValues) => {
      const newCampaignUuid = values.campaign?.uuid;

      if (!newCampaignUuid || !campaignId || newCampaignUuid === campaignId) {
        return;
      }

      const routeCreator = createRouteCreator(type);
      navigate(routeCreator.updateWithTab(newCampaignUuid, offerId), { replace: true });
    },
    [campaignId, navigate, offerId, type],
  );

  const configureProps = useGetConfigureFormProps<
    OfferConfigureFormValues,
    OfferConfigureFormInitialValues
  >(props, transformOfferToInitialValuesWithProductGroups, getConfigureFormOperations, {
    onSubmitSuccess: handleSubmitSuccess,
  });

  return <ConfigureForm {...configureProps} />;
};
